import React from "react";
import { Col, Row } from "antd";
import { FormItem } from "Components/form";
import FetchSelect from "Components/fetch-select";

export default function HousingTenantForm({
  form,
  readOnly = false,
  ...props
}) {
  const { control, errors } = form;

  return (
    <Col xs={24} md={24} lg={12}>
      <FormItem htmlFor="taskDistinctionTitle" label="Görev Ayrım Unvanı">
        <FetchSelect
          api="/masterdata/taskdistinctiontitles"
          readOnly={readOnly}
          form={form}
          field="taskDistinctionTitle"
          placeholder="Görev ayrım unvanı seçiniz"
        />
      </FormItem>
    </Col>
  );
}
